import SubscriptionService from '@/services/SubscriptionService.js'

export const state = {
  subscription: {}
}

export const mutations = {
  SET_SUBSCRIPTION(state, subscription) {
    state.subscription = subscription
  }
}

export const actions = {
  insertSubscriptionDetails({ dispatch }, subscriptionDetails) {
    return SubscriptionService.postSubscription(subscriptionDetails)
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Your new subscription details has been created!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem creating your subscription details: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchSubscriptionDetails({ dispatch, commit }, productId) {
    return new Promise((resolve, reject) => {
      SubscriptionService.getSubscription(productId)
        .then(response => {
          const notification = {
            type: 'success',
            message: 'Your subscription details has been fetched!'
          }
          dispatch('notification/add', notification, { root: true })
          if(response.data && response.data.length > 0) {
            commit('SET_SUBSCRIPTION',response.data[0])
            return resolve(response.data[0])
          }
          return resolve(null)
        })
        .catch(error => {
          const notification = {
            type: 'error',
            message: 'There was a problem fetching your subscription details: ' + error.message
          }
          dispatch('notification/add', notification, { root: true })
          return reject(error)
        })
    })
  },
  fetchSubscriptionPlanDetails({ dispatch }) {
    return SubscriptionService.getSubscriptionPlan()
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Your subscription plan details has been fetched!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching your subscription plan details: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  createStripeCustomer({ dispatch }) {
    return SubscriptionService.createCustomer()
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Customer has been created successfully!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data.id
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem creating customer: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  createSubscription({ dispatch }, subscriptionDetails) {
    return SubscriptionService.createSubscription(subscriptionDetails)
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Your new subscription has been created!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem creating your subscription: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  updateSubscription({ dispatch }, subscriptionDetails) {
  return SubscriptionService.updateSubscription(subscriptionDetails)
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Your subscription has been updated!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem updating your subscription: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  updateSubscriptionCard({ dispatch }, subscriptionDetails) {
    return SubscriptionService.updateSubscriptionCard(subscriptionDetails)
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Your subscription has been updated!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem updating your subscription: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  deleteSubscription({ dispatch }) {
    return SubscriptionService.cancelSubscription()
      .then(response => {
        const notification = {
          type: 'success',
          message: 'Your subscription has been deleted!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem deleting your subscription: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  saveFeedback({ dispatch }, feedbackJson) {
    return SubscriptionService.saveFeedback(feedbackJson)
        .then(response => {
          const notification = {
            type: 'success',
            message: 'Your feedback has been saved!'
          }
          dispatch('notification/add', notification, { root: true })
          return response.data
        })
        .catch(error => {
          const notification = {
            type: 'error',
            message: 'There was a problem saving your feedback: ' + error.message
          }
          dispatch('notification/add', notification, { root: true })
          throw error
        })
    }
}
